//Controla as permissões de acesso aos componentes
import { useUserStore } from "~/stores/usuario_store";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore();
  if (process.server) return;

  let toComponent = to.matched[0]?.path.split("/")[1];

  if (toComponent == "") return;

  if (toComponent == "login" || toComponent == "usuarios" || toComponent == "error" || toComponent == 'perfil') return;

  //se no url o 'componente' for categorias, pega o parametro do componente que está sendo acessado e atribui a variavel toComponent
  if (toComponent == "categorias") toComponent = to.params.componente;

  let perfilUsuario = userStore.user.usuario.perfil.toLowerCase();

  if (perfilUsuario === "developer" || perfilUsuario === "administrador") return;

  await useAPI.get(`/componente/getComponente/com_${toComponent}`, userStore.user.token).then(({ data }) => {
    if (data.error) {
      console.error("Sem permissão para acessar este componente");
      return navigateTo("/", { external: true });
    }

    if (to.matched[0].path.split("/")[1] == "categorias") {
      if (!data.configuracoes[perfilUsuario]?.categorias) {
        alert("Sem permissão para acessar este recurso");
        console.error("Sem permissão para acessar este recurso");
        return navigateTo("/", { external: true });
      } else {
        return null;
      }
    }

    if (!data.configuracoes[perfilUsuario]?.componente) {
      alert("Sem permissão para acessar este componente");
      console.error("Sem permissão para acessar este componente");
      return navigateTo("/", { external: true });
    } else {
      return null;
    }
  });

  return null;
});
